export default __webpack_public_path__ + "static/media/drop-a-hint.16287eb9.png";